import type { IconProps } from '@chakra-ui/icons';

export const defaultOptions: IconProps = {
  fill: 'none',
  strokeWidth: 1.5,
  viewBox: '-0.25 -0.25 14.5 14.5',
};
